import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateGroupActions } from "store/ducks/settings/groups";

export function* updateGroupRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/groups/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateGroupActions.success(data));
    notify("success", "Grupo atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateGroupActions.failure(errorMessage));
  }
}
